import "./styles/tenderAdd.css";

import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { withNamespaces } from "react-i18next";

import TenderAddStepOne from "./TenderAddStepOne";
import TenderAddStepTwo from "./TenderAddStepTwo";
import { CrudContextValue } from "../../../context/CrudContext";
import { AuthContextValue } from "../../../context/AuthContext";
import { toast } from "react-toastify";
import WhiteButton from "../../../components/form_components/Buttons/WhiteButton/WhiteButton";
import { GetContextValue } from "../../../context/GetContext";

function TenderAdd({ t }) {
  const navigate = useNavigate();

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const { token } = AuthContextValue();
  const { mySuppliers } = GetContextValue();
  const { createMethod } = CrudContextValue();

  const [addTenderLoading, setAddTenderLoading] = useState(false);

  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState({});

  const [selectedCategories, setSelectedCategories] = useState([]);
  const [properties, setProperties] = useState([]);

  const handleNext = (data) => {
    setFormData({ ...formData, ...data });
    setStep(step + 1);
  };

  const handlePrev = (data) => {
    setFormData({ ...formData, ...data });
    setStep(step - 1);
  };

  const handleSubmit = async (data) => {
    setFormData({ ...formData, ...data });

    const newCategories = formData.categoryId.map((category) => {
      if (category.categoryId) {
        return category.categoryId;
      } else {
        return category;
      }
    });

    const propertiesFilter = formData.properties.map((prop) => ({
      name: prop.name,
      value: prop.value,
    }));

    const newTender = {
      ...formData,
      ...data,
      categoryId: newCategories,
      minPrice:
        typeof formData.minPrice === "string"
          ? parseInt(formData.minPrice.replace(/[,.]/g, ""))
          : formData.minPrice,
      maxPrice:
        typeof formData.maxPrice === "string"
          ? parseInt(formData.maxPrice.replace(/[,.]/g, ""))
          : formData.maxPrice,
      properties: propertiesFilter,
      details: {
        frequency: formData.details.frequency,
        startDate: formData.details.startDate,
        finishDate: formData.details.finishDate,
        quantityDistribution: formData.details.quantityDistribution,
      },
      deadline: formData.recursive
        ? formData.details.finishDate
        : formData.deadline,
    };

    setAddTenderLoading(true);
    console.log("newTender : ", newTender);

    const response = await createMethod(
      process.env.REACT_APP_POST_ADD_TENDER_URL,
      JSON.stringify(newTender),
      token
    );

    if (response && !response.catchError && !response.isError) {
      toast.info(t("message_create_tender_success"), {
        autoClose: 3000, // 2 saniye sonra otomatik olarak kapat
      });

      setTimeout(() => {
        navigate("/tenders");
      }, 3000);
    }

    setAddTenderLoading(false);

    setStep(1);
    setFormData({});
  };

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <>
      {mySuppliers === null && (
        <div className="no-supplier">
          <p className="no-supplier-text">
            {t("message_no_supplier_create_tender")}
          </p>

          <div className="no-supplier-button-group">
            <WhiteButton
              icon={<i className="fa-solid fa-store"></i>}
              text={t("button_suppliers")}
              onClick={() => navigate("/suppliers")}
            />
            <WhiteButton
              icon={<i className="fa-solid fa-xmark"></i>}
              text={t("button_edit_cancel")}
              onClick={() => navigate(-1)}
            />
          </div>
        </div>
      )}
      <div
        className={`tender-add  ${
          mySuppliers === null ? "no-supplier-tender-add" : null
        }`}
      >
        {windowWidth < 1028 ? (
          <>
            {step === 1 ? (
              <div className={`step-one ${step === 1 ? "" : "disabled"}`}>
                <TenderAddStepOne
                  onNext={handleNext}
                  formData={formData}
                  step={step}
                  selectedCategories={selectedCategories}
                  setSelectedCategories={setSelectedCategories}
                  properties={properties}
                  setProperties={setProperties}
                />
              </div>
            ) : step === 2 ? (
              <div
                className={`step-two ${
                  step !== 2 || addTenderLoading ? "disabled" : ""
                }`}
              >
                <TenderAddStepTwo
                  onPrev={handlePrev}
                  onSubmit={handleSubmit}
                  formData={formData}
                  setFormData={setFormData}
                  step={step}
                  setStep={setStep}
                />
              </div>
            ) : (
              "null"
            )}
          </>
        ) : (
          <>
            <div className={`step-one ${step === 1 ? "" : "disabled"}`}>
              <TenderAddStepOne
                onNext={handleNext}
                formData={formData}
                step={step}
                selectedCategories={selectedCategories}
                setSelectedCategories={setSelectedCategories}
                properties={properties}
                setProperties={setProperties}
              />
            </div>
            <div className={`step-two ${step === 2 ? "" : "disabled"}`}>
              <TenderAddStepTwo
                onPrev={handlePrev}
                onSubmit={handleSubmit}
                // onSubmit={demoAddTender}
                formData={formData}
                setFormData={setFormData}
                step={step}
                setStep={setStep}
                addTenderLoading={addTenderLoading}
              />
            </div>
          </>
        )}
      </div>
    </>
  );
}

export default withNamespaces()(TenderAdd);
